import styled from 'styled-components';

// Card alinhado com design X/Twitter — sem radius, sem padding interno
// (paineis filhos controlam seu proprio padding com hairlines), sem
// shadow. Border 1px define a borda externa do painel; quando irmaos
// encostam, a borda compartilhada vira o divisor 1px.
export const Container = styled.div`
  display: flex;
  width: ${(props) => props.width};
  min-width: ${(props) => (props.minWidth ? props.minWidth : '')};
  height: ${(props) => (props.height ? props.height : '44vh')};
  background: ${(props) => props.theme.colors.card};
  overflow: hidden;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid ${(props) => props.theme.colors.disabled};
  padding: 0;
  box-sizing: border-box;
  flex-wrap: ${(props) => (props.$wrap ? 'wrap' : 'unset')};
`;

export const ContainerParque = styled(Container)`
  box-sizing: border-box;
  margin: 0px;
`;
